export default __webpack_public_path__ + "static/media/transaction.d0b9bcca.svg";